import marketingService from "../../services/marketingService";
import inscriptionService from "../../services/inscriptionService";
import rateService from "../../services/rateService";
import router from "../../router";
import moment from "moment"
import geoService from "../../services/geoService";

const getDefaultState = () => {
    return {
        loading: false,
        valid: false,
        customerId: "",
        uuid1: "",
        uuid2: "",
        subscriptionId: null,
        subscriptionGuid: null,
        mailDate: null,
        validUntil: null,
        scenario: '',
        customer: {},
        contracts: [],
        type: {},
        region: '',
        rateCards: {
            electricity: null,
            gas: null
        },
        selected: [],
        offer: {},
        providers: [],
        products: {},
        confirmed: false,
        outdated: false
    }
}

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setCustomerId(state, value) {
            state.customerId = value;
        },
        setUuid1(state, value) {
            state.uuid1 = value;
        },
        setUuid2(state, value) {
            state.uuid2 = value;
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setValid(state, value) {
            state.valid = value;
        },
        setSubscriptionId(state, value) {
            state.subscriptionId = value;
        },
        setSubscriptionGuid(state, value) {
            state.subscriptionGuid = value;
        },
        setMailDate(state, value) {
            state.mailDate = value;
        },
        setValidUntil(state, value) {
            state.validUntil = value;
        },
        setScenario(state, value) {
            state.scenario = value;
        },
        setCustomer(state, value) {
            state.customer = value;
        },
        setRegion(state, value) {
            state.region = value;
        },
        setRateCards(state, value) {
            state.rateCards = value;
        },
        setContracts(state, value) {
            state.contracts = value;
        },
        setType(state, value) {
            state.type = value;
        },
        setSelected(state, value) {
            state.selected = value;
        },
        setOffer(state, value) {
            state.offer = value;
        },
        setProviders(state, value) {
            state.providers = value;
        },
        setProducts(state, value) {
            state.products = value;
        },
        setConfirmed(state, value) {
            state.confirmed = value;
        },
        setOutdated(state, value) {
            state.outdated = value;
        },
    },
    actions: {
        async getCustomerAndContracts(context) {
            try {
                context.commit("setLoading", true);
                context.commit('setOutdated', false);
                let response = await marketingService.getCustomerAndContracts();
                // console.log(response);
                context.commit("setCustomer", response.customer);
                context.commit("setContracts", response.contracts);
                context.commit("setType", response.type);
                context.commit("setScenario", response.scenario);
                context.commit("setValidUntil", response.valid_until);
                context.commit("setMailDate", response.mail_date);
                context.commit("setConfirmed", response.confirmed);

                if (response.type === 'COLD_LOSS') {
                    context.commit("setSubscriptionGuid", response.subscription_guid);
                    context.commit('setSelected',
                        context.state.contracts.map(c => c.id)
                    )
                    const products = {
                        'elec': '900106',
                        'gas': '900113'
                    }
                    await context.dispatch("getRateCards", products);
                    const res = await geoService.getRegion(context.state.customer.address.postCode);
                    context.commit("setRegion", res.region);
                }

                if (response.type === 'HOT_LOSS') {
                    context.commit("setOffer", response.offer);
                    let contracts = router.currentRoute.query['contracts[]']
                    if (! Array.isArray(contracts)) {
                        contracts = [contracts]
                    }
                    context.commit('setSelected', contracts);

                    let products = {};
                    let payload = {}

                    // for specific offers, a product could be chosen
                    if (router.currentRoute.query.el !== undefined) {
                        products.elec = router.currentRoute.query.el
                    }
                    if (router.currentRoute.query.gas !== undefined) {
                        products.gas = router.currentRoute.query.gas
                    }

                    if (! context.state.confirmed) {
                        if (Object.keys(products).length > 0) {
                            context.commit('setProducts', products);
                            context.dispatch("getRateCards", products);

                            context.state.contracts.forEach((contract) => {
                                if (context.state.selected.includes(contract.id)) {
                                    if (contract.energy === 'electricity') {
                                        payload.electricity = {}
                                        payload.electricity.contract_id = contract.id;
                                        payload.electricity.product_code = context.state.products.elec;
                                    }
                                    if (contract.energy === 'gas') {
                                        payload.gas = {}
                                        payload.gas.contract_id = contract.id
                                        payload.gas.product_code = context.state.products.gas
                                    }
                                }
                            })
                        }

                        // update Hot Loss with products codes, ip and validation_date
                        await marketingService.updateLoss(payload);

                        let providers = []
                        const postalCodes = [...new Set(context.state.contracts.map(contract => contract.address.postCode))]

                      const getProviders = async postalCodes => {
                        for (const pc of postalCodes) {
                          const res = await geoService.getHotlossProviders()

                          if (res.providers) {
                            res.providers.forEach(prov => {
                              providers.push(prov)
                            })
                          }
                        }
                      }

                        await getProviders(postalCodes)
                        const getUniqueProviders = providers => {
                            return providers.filter((prov, index, self) =>
                                self.findIndex(p => JSON.stringify(p) === JSON.stringify(prov)) === index
                            )
                        }
                        context.commit('setProviders', getUniqueProviders(providers))
                    }
                }
                context.commit("setValid", true);
                context.commit("setLoading", false);
                return true;
            } catch (error) {
                if (error.response.data === 'OUTDATED_LOSS') {
                    context.commit('setOutdated', true);
                    context.commit("setLoading", false);
                } else {
                    context.commit("setLoading", false);
                    router.push('/')
                    throw error;
                }
            }
        },
        async getRateCards(context, products) {
            context.commit("setLoading", true);

            let date = moment(context.state.mailDate);
            if (context.state.outdated) date = moment();
            date = date.format("YYYY-MM-DD");

            let rateCards = {};

            if (context.getters['hasElec']) {
                await rateService.getRateCards(
                    context.state.customer.language.toUpperCase(),
                    context.state.contracts.find(c => c.energy === 'electricity').address.postCode,
                    context.state.customer.type,
                    'electricity',
                    date,
                    products.elec
                ).catch((e) => {
                    console.log(e);
                }).then((resp) => {
                    rateCards.electricity = resp;
                });
            }

            if (context.getters['hasGas']) {
                await rateService.getRateCards(
                    context.state.customer.language.toUpperCase(),
                    context.state.contracts.find(c => c.energy === 'gas').address.postCode,
                    context.state.customer.type,
                    'gas',
                    date,
                    products.gas
                ).catch((e) => {
                    console.log(e);
                }).then((resp) => {
                    rateCards.gas = resp
                });
            }
            context.commit("setRateCards", rateCards)
            context.commit("setLoading", false);
        },
        async createSubscription(context, complete) {
            context.commit("setLoading", true);
            if (context.state.subscriptionId && context.state.subscriptionGuid) {
                console.log(context.state.subscriptionGuid)
                // console.log('redirect', context.state.subscriptionGuid);
                router.push({path: `/${context.state.subscriptionId}/${context.state.subscriptionGuid}?newSession`});
            } else {

                try {
                    const data = {
                        complete: complete,
                        contractIds: context.state.selected
                    }
                    let response = await inscriptionService.createSubscriptionFromLoss(data)
                    context.commit("setSubscriptionId", response.id)
                    context.commit("setSubscriptionGuid", response.guid)
                    const payload = {
                        subscriptionId: (response.id).toString(),
                        contractIds: context.state.selected
                    }
                    await marketingService.confirm(payload)
                    // console.log('created and redirect', loss.subscriptionId);
                    router.push({path: `/${context.state.subscriptionId}/${context.state.subscriptionGuid}?newSession`});
                } catch (error) {
                    context.commit("setLoading", false);
                    throw error;
                }
            }
        },
        async confirmHotLoss(context, provider) {
            context.commit("setLoading", true);
            await marketingService.confirm({
                contracts: context.state.selected,
                supplier: provider.toString()
            }).catch(error => {
                router.push({name: "ServerError"})
            })
            context.commit('setConfirmed', true)
            context.commit("setLoading", false);
        },
    },
    getters: {
        hasElec: state => {
            return state.contracts.some(c => c.energy === "electricity")
        },
        hasGas: state => {
            return state.contracts.some(c => c.energy === "gas")
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/comeback.js